import React from 'react'
import { Tooltip } from 'antd'
import { EyeInvisibleOutlined, EyeOutlined, LoadingOutlined } from '@ant-design/icons'
import './visibility_toggle.less'

// Переключатель «показывается / скрыт».
// Обычный — пилюля с бегунком и подписью состояния; minimal — только дорожка с бегунком, подпись уходит в подсказку.
// Пока идёт запрос, бегунок крутит загрузку и повторные нажатия не проходят.
export const VisibilityToggle = ({ checked, onChange, onLabel, offLabel, hint, loading, disabled, size = 'default', minimal }: {
    checked: boolean
    onChange: (checked: boolean) => void
    onLabel: string
    offLabel: string
    // Подсказка по наведению — что произойдёт по нажатию
    hint?: React.ReactNode
    loading?: boolean
    disabled?: boolean
    size?: 'default' | 'small'
    minimal?: boolean
}) => {
    const className = [
        'vt',
        checked ? 'vt--on' : 'vt--off',
        loading && 'vt--loading',
        size === 'small' && 'vt--small',
        minimal && 'vt--minimal',
    ].filter(Boolean).join(' ')

    const label = checked ? onLabel : offLabel
    const knobIcon = loading
        ? <LoadingOutlined />
        : minimal ? null : checked ? <EyeOutlined /> : <EyeInvisibleOutlined />

    const toggle = (
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            aria-busy={!!loading}
            aria-label={minimal ? label : undefined}
            className={className}
            disabled={disabled}
            onClick={() => !loading && onChange(!checked)}
        >
            <span className="vt__track">
                <span className="vt__knob">{knobIcon}</span>
            </span>
            {!minimal && <span className="vt__label">{label}</span>}
        </button>
    )

    const title = hint ?? (minimal ? label : undefined)
    return title ? <Tooltip title={title} mouseEnterDelay={0.4}>{toggle}</Tooltip> : toggle
}
